<template>
  <div class="row">
    <div class="col-4 col-md-4 col-lg-4 logoheader" :class="!isHomePage && 'point'" style="display: table;" v-on:click.prevent="home">
      <h2 align="left" style="padding: 1em 0 0 2.8em;" class="pagetitle" v-if="config.codCliente == 'iama'">
        IAMA <i>Suite</i>
      </h2>
      <h2 align="left" style="padding: 1em 0 0 2.8em;" class="pagetitle" v-else>
        {{config.title}}
      </h2>
    </div>
    <div class="col-4 col-md-4 col-lg-4">    
      <h2 style="padding: 1em 0 0 0; text-align:center" class="pagetitle">{{pageTitle}} </h2>

    </div>
    <div class="col-4 col-md-4 col-lg-4" style="color: #366079">
      <b-dropdown class="fa fa-user" variant="white" :text="loggedUser ? loggedUser.description : ''" id="dropdown-1" style="float:right;padding-top:1.7em; ">
        <!--<span>{{loggedUser ? loggedUser.description : ''}}</span>-->
        <b-dropdown-item href="#"> <span style="cursor: pointer;" v-on:click.prevent="changePassword" v-if="loggedUser && loggedUser.cambioPasswordEnabled">Cambio password</span> </b-dropdown-item>
        <b-dropdown-item href="#"> <span style="cursor: pointer;" v-on:click.prevent="doLogout">Logout</span> </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>




</template>
<script>
import Vue from "vue";
import LoginService from "../services/login";
import config from "@/services/config";

const loginService = new LoginService();

export default Vue.extend({
  props: ["user", "title", "homeRoute", "isHome"],
  data() {
    return {
      loggedUser: this.$props.user,
      pageTitle: "",
      isHomePage: this.$props.isHome == true,
      config,
    }
  },
  methods: {
    route: function(module, user, homeRoute) {
      var params = {};
      if (user != undefined) {
        params.user = user;
      }
      if (homeRoute != undefined) {
        params.homeRoute = homeRoute;
      }

      if (Object.keys(params).length !== 0) {
        this.$router.push({ name: module, params: params });
      } else {
        this.$router.push({ name: module });
      }
    },
    doLogout: async function() {
      const serviceCallReturnValue = await loginService.doLogout() 
        .then((result) => {
          this.$store.dispatch("filters/reset");
          this.route('login');
          return null;
        })
        .catch(function(e) {
          console.log("Errore generico");
        });
    },
    changePassword: function() {
      this.route('cambio-password', this.loggedUser, this.$props.homeRoute);
    },
    home: function() {
      const _home = this.$props.homeRoute != undefined ? this.$props.homeRoute : "home";
      this.route(_home, this.loggedUser, this.$props.homeRoute);
    },
  },
  mounted() {
    if (this.title !== undefined && this.title != null) {
      this.pageTitle = this.title;
    }
  }
});
</script>

<style scoped>
nav {
  background: #FFF;
  padding: 20px 20px 20px 20px;
}
nav a {
  padding: 10px;
  text-decoration: none;
  color: #FFF;
  font-weight: bold;
  margin-right: 15px;
}
.point {
  cursor: pointer;
}
</style>
